<div class="map-wrapper" #mapWrapper [style.height]="containerHeight">
  <div #mapContainer class="map"></div>

  <div class="map-style-controls">
    <button
      class="map-control-btn"
      [class.active]="currentMapStyle === 'streets'"
      (click)="switchMapStyle('streets')"
      title="Street View"
      [disabled]="isLoading">
      Map
    </button>

    <button
      class="map-control-btn"
      [class.active]="currentMapStyle === 'hybrid'"
      (click)="switchMapStyle('hybrid')"
      title="Hybrid View"
      [disabled]="isLoading">
      Satellite
    </button>
  </div>

  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Loading map…</p>
  </div>
</div>